<div class="ai-chat-input-mobile">
  <form class="ai-chat-input-mobile--form" [formGroup]="formGroup">
    <input formControlName="value"
           placeholder="Describe your ideal trip below and get your AI plan."
           type="text"
           class="ai-chat-input-mobile--input"
           [readonly]="aiChatMobileComponent.isFetchingMap"
           #inputRef>
    <button type="submit" class="ai-chat-input-mobile--send"
            (click)="sendMessageHandle()"
            [class.disabled]="inputRef.value.length < 14"
            [disabled]="inputRef.value.length < 14 || aiChatMobileComponent.isFetchingMap">
      <mat-icon [svgIcon]="eSvgIcons.CHAT_SEND"></mat-icon>
    </button>
  </form>
</div>
